import React from 'react';
import { PageType, BucketLayout } from 'enums';
import { FormattedMessage } from 'react-intl';
import Bucket from 'page/buckets/Bucket';
import SearchContainer from 'search/ElasticSearchContainer';
import injectIntl from 'common/injectIntl';
import SearchAPI from '../../lib/api/SearchAPI';

function appendScore(bucket) {
    bucket.contents.forEach((content) => {
        if (content.name) {
            if (!content.name.includes('Score')) {
                content.name = `${content.name} (Score: ${content.score})`;
            }
        }
    });

    return bucket.contents;
}

class SearchResultContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = { buckets: [], currentSearchQuery: '' };
    }
    componentDidMount() {
        // Inital API call before the component renders.
        this.fillBuckets();
    }
    componentDidUpdate(prevProps) {
        if (this.props.searchTerm !== prevProps.searchTerm) {
            this.fillBuckets();
        }
    }
    fillBuckets() {
        // The API call and state change, which triggers componentWillUpdate, will only happen
        // if the new string query is different vs. the currentSearchQuery
        if (this.state.currentSearchQuery.localeCompare(this.props.searchTerm) !== 0) {
            this.setState({ currentSearchQuery: this.props.searchTerm });
            SearchAPI.getSearchResults({ q: encodeURIComponent(this.props.searchTerm), size: 50, env: 'test' })
                .then(({ page }) => (this.setState({ buckets: page.buckets })));
        }
    }
    render() {
        const { messages } = this.props;
        const headerOfContainer = (
            <div className="search-results-header" style={{ marginLeft: '20px' }}>
                <br />
                <center>
                    <SearchContainer />
                    <br />
                    <h1>
                        <FormattedMessage
                            {...messages['search.results.message']}
                            values={{
                                query: <strong>{this.props.searchTerm}</strong>
                            }}
                        />
                    </h1>
                </center>
                <br />
                <hr width="98%" />
                <br />
            </div>
        );

        let bucketResults;
        if (this.state.buckets) {
            bucketResults = this.state.buckets.map((bucket, index) => (
                <Bucket
                    bucektId={bucket.id}
                    contents={(appendScore(bucket))}
                    groupId={index}
                    index={index}
                    key={bucket.id}
                    layoutType={BucketLayout.DEFAULT_UNLIMITED}
                    link={null}
                    metadata={bucket.metadata}
                    name={bucket.name}
                    pageType={PageType.SEARCH}
                    tags={[]}
                />
            ));
        }
        return (
            <div className="search-result-container" style={{ backgroundColor: 'white' }}>
                {headerOfContainer}
                {bucketResults}
            </div>
        );
    }
}

SearchResultContainer.propTypes = {
    searchTerm: React.PropTypes.string,
    messages: React.PropTypes.object.isRequired
};

export default injectIntl(SearchResultContainer);



// WEBPACK FOOTER //
// ./app/page/search/SearchResultsContainer.js